import React from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

export default class Confirm extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
			c1 : '',
			c2 : '',
			c3 : '',
			c4 : '',
			currentInput : '',
			keyboardOpen : false
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.c1 = React.createRef();
		this.c2 = React.createRef();
		this.c3 = React.createRef();
		this.c4 = React.createRef();
		this.setCurrentInput = this.setCurrentInput.bind(this);
		this.handleChangeByKeyboard = this.handleChangeByKeyboard.bind(this);
		this.isKiosk = false;
		this.keyboard = React.createRef();
		let queryString = window.location.search;
		if (queryString=='?kiosk=1') this.isKiosk = true;
    }
	
	setCurrentInput(e) {
		this.setState({
			currentInput : e.target.id
		});
	}
	
	getCode() {
		return this.state.c1 + 
			this.state.c2 + 
			this.state.c3 + 
			this.state.c4; 
	}
	
	handleSubmit(e){
		e.preventDefault();
		if (this.state.c1.length==0 || 
		this.state.c2.length==0 || 
		this.state.c3.length==0 || 
		this.state.c4.length==0) return;
		console.log('submit');
		let user = this.props.user;
		let postData = {
			msisdn : user.phone,
			code: this.getCode(),
			fullname : user.name,
			email : user.email,
			items : JSON.stringify(this.props.selected)
		}
		let postEnc = [];
		for (let f in postData) {
			let encodedKey = encodeURIComponent(f);
			let encodedValue = encodeURIComponent(postData[f]);
			postEnc.push(encodedKey + "=" + encodedValue);
		}
		let formBody = postEnc.join("&");
		fetch('/brandquiz/reg', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			},
			body: formBody
		})
		.then(response => {
			if (response.status != 200 && response.status != 400)
				throw new Error('Ошибка отправки запроса на сервер');
			return response;
		})
		.then(response => response.json())
		.then(data => {
			if ('error' in data) {
				alert(data.error);
				return;
			}
			this.props.changeStep('success');
		}).catch(err => {
			alert(err.message);
		});
	}
	
	handleChange(e) {
		let field = e.target.id;
		//let val = e.target.value.replace(/\D/,'');
		let val = e.target.value.toString();
		if (val.length>0 && field == 'c1')
			this.c2.current.focus();
		if (val.length>0 && field == 'c2')
			this.c3.current.focus();
		if (val.length>0 && field == 'c3')
			this.c4.current.focus();
		
		if (val.length==0 && field == 'c2')
			this.c1.current.focus();
		if (val.length==0 && field == 'c3')
			this.c2.current.focus();
		if (val.length==0 && field == 'c4')
			this.c3.current.focus();
		if (val.length>1) return;
		this.setState({[field]: val});
	}
	
	handleChangeByKeyboard(inputVal){
		let field = this.state.currentInput;
		let val = inputVal[field];
		if (val.length>0 && field == 'c1')
			this.c2.current.focus();
		if (val.length>0 && field == 'c2')
			this.c3.current.focus();
		if (val.length>0 && field == 'c3')
			this.c4.current.focus();
		
		if (val.length==0 && field == 'c2')
			this.c1.current.focus();
		if (val.length==0 && field == 'c3')
			this.c2.current.focus();
		if (val.length==0 && field == 'c4')
			this.c3.current.focus();
		if (val.length>1) return;
		this.setState(inputVal);
	}
	
	render() {
		let keysDisplay = {
			"{backspace}": "⌫",
		}
		let {currentInput} = this.state;
		return (
			<form class="submit-form" onSubmit={this.handleSubmit}>
				<label>Код подтверждения</label>
				<div class="code-row">
					<input ref={this.c1} id="c1" min={0} max={9} type="number" value={this.state.c1} onChange={this.handleChange} onFocus={this.setCurrentInput}/>
					<input ref={this.c2} id="c2"  min={0} max={9} type="number" value={this.state.c2} onChange={this.handleChange} onFocus={this.setCurrentInput}/>
					<input ref={this.c3} id="c3"  min={0} max={9} type="number" value={this.state.c3} onChange={this.handleChange} onFocus={this.setCurrentInput}/>
					<input ref={this.c4} id="c4"  min={0} max={9} type="number" value={this.state.c4} onChange={this.handleChange} onFocus={this.setCurrentInput}/>
				</div>
				<div class="form-note">Соглашаясь, Вы принимаете правила (полная версия по ссылке), разрешаете обрабатывать и использовать свои персональные данные, с целью  проведения исследований, осуществления сервисных коммуникаций и рекламных рассылок об акциях, товарах и услугах, в соответствии со 152-ФЗ.</div>
				<div class="button-row">
					<button class="btn btn-arrow" type="submit">Отправить</button>
				</div>
				{this.isKiosk &&
					<div className={'keyboardContainer confirm'}>
						<Keyboard
							keyboardRef={r => (this.keyboard.current = r)}
							inputName={currentInput}
							layoutName={'numbers'}
							onChangeAll={this.handleChangeByKeyboard}
							layout={{
								numbers: ["1 2 3", "4 5 6", "7 8 9", "0 {backspace}"]
							}}
							display={keysDisplay}
						/>
					</div>
				}
			</form>
		);
	}

}